import React, {memo, useState} from "react";
import ContentBox from "../../../Components/ContentBox/ContentBox";
import {useFacilityTypes} from "../../../Api/facility-types";
import {SimplexionTable} from "../../../Lib/simplexion-table/SimplexionTable";
import {baseTableStyles} from "../../../Lib/simplexion-table/baseStyle";
import {makeStyles} from "@material-ui/core";
import {makeTableStyles} from "../../../Components/Table/tableStyles"
import {FilterField} from "../../../Components/Table/FilterField";
import {customActions} from "../../../Lib/simplexion-table/templates/action-buttons";
import {inputFieldStyles} from "../../../Lib/simplexion-table/templates/text-input";
import {updatableCheckBoxStyle} from "../../../Lib/simplexion-table/templates/checkbox-input";
import debug from "../../../Lib/debug"
import LinearProgress from "@material-ui/core/LinearProgress";
import Section from "../../../Lib/form/Components/Section/Section";


const useTableStyles = makeStyles(makeTableStyles(baseTableStyles, updatableCheckBoxStyle, inputFieldStyles));

const List = memo((props) => {

    debug("RENDER", "useForm", () => [" -> List_Of_Clients", props]);

    const {path, hasAdminRoles} = props;

    const {loadingStatus, data} = useFacilityTypes();

    const urlNs = path[0].url + "/";

    const tableClasses = useTableStyles();

    const [state, setState] = useState('');

    const handleFilter = val => setState(val);

    const tableConfig = {
        id: 'facility-types-table',
        nameSpace: 'facilities',
        stickyHeader: true,
        sortable: true,
        styles: tableClasses,
        columns: [
            {
                accessor: 'id',
            },
            {
                accessor: 'name',
            },
            {
                accessor: 'action',
                renderer: (...args) => customActions(true, false, urlNs, ...args),
                sortable: true,
            },
        ],
    };

    return (
        <ContentBox path={path} add={hasAdminRoles ? (urlNs + "add") : null}>
            <Section>
                <FilterField handler={handleFilter}/>
                {loadingStatus > 0 ? <LinearProgress/> : null}
                <SimplexionTable tableConfig={tableConfig} data={data} loadingStatus={loadingStatus}
                                 filterValue={state}/>
            </Section>
        </ContentBox>
    );
});

export default List;